import { render, staticRenderFns } from "./RecordInfoField.vue?vue&type=template&id=05881eb3&"
import script from "./RecordInfoField.vue?vue&type=script&lang=js&"
export * from "./RecordInfoField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports